/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderCertIcon24Solid = forwardRef('FolderCertIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a2 2 0 0 1 2-2h4.868a2 2 0 0 1 1.715.971l.399.665a.75.75 0 0 0 .643.364H18a4 4 0 0 1 4 4v8a4.002 4.002 0 0 1-3 3.874v2.297a.8.8 0 0 1-1.261.653l-1.124-.793a.2.2 0 0 0-.23 0l-1.124.793A.8.8 0 0 1 14 23.171V21H6a4 4 0 0 1-4-4V5Zm3.5 4a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5h-13Zm13.625 7.5a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" })));
});
